import type { FaireProductEntity } from "../../entity_types/product";

export const p_m38fnushgg: FaireProductEntity = {
  token: "p_m38fnushgg",
  type: "product",
  name: "Woon Stir Fry Sauce",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/65753fe89941bc53d1a1327eaf71d84e1c87316d7e699ab5b8c1ea4e6e675e2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c6cb5c69f742ae3ba4aad2b46518199cbef91be36b8ad3ffa0dc1e44ad2437c.jpeg",
    "https://cdn.faire.com/fastly/a7887f8ea0d13aef74e9ebe0d692561b96113108fa34295f1813a2fc40ac624c.jpeg",
    "https://cdn.faire.com/fastly/1c9ae23bbf24da43fc19a4d279231f0fa144ffd4f4fa02ea430ee273748356ec.jpeg",
    "https://cdn.faire.com/fastly/5ee36497950a732a421b12299dd51112328e2af2ad0fb310db08b3420a516c96.jpeg",
    "https://cdn.faire.com/fastly/91e167dc4cd7000adcab4c0f4ce852a230d219186db806758fff43c15a97180d.jpeg",
    "https://cdn.faire.com/fastly/1ed798f144be06bd8762eec28d72d5cf547a574e6256b3a23f8ed90f51eaac9c.jpeg",
    "https://cdn.faire.com/fastly/5643fe1aacee3f615a3d0decc6f94b8727028e9c347845f53a87a4f0b263d1fd.jpeg"
  ],
  priceDollars: 7.2,
  description: "Stir Fry Sauce is a gluten-free cooking sauce and marinade filled with umami. This is the same sauces we use in the restaurant for our most popular dish, the Beef Noodles. We recommend adding Stir Fry Sauce to noodles, rice, vegetables, meats, fish, marinades, and more.",
  tags: [],
  msrpDollars: 12,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:01.421Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
